import TeamTable from "../TeamTable";

const Distance30 = () => {
  return <TeamTable  distance={"30"} targetType={"PRE"}/>;
};
export default Distance30;
